import * as Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import * as React from "react";
import { DateHelper } from "../../../../react-core/Helpers/DateHelper";
import { JsonDateParser } from "../../../../react-core/Utils/JsonDateParser";

export interface ILineSeries {
    name: string;
    data: Array<{
        xValue: number;
        yValue: number;
    }>;
}

interface ILineChartProps {
    title?: string;
    yAxis?: {
        title?: string;
    };
    xAxis: {
        title?: string;
        type: Highcharts.AxisTypeValue;
    };
    tooltipFormatter: (tooltipContext: Highcharts.TooltipFormatterContextObject) => string;
    series: ILineSeries[];
}

const LineChart = (props: ILineChartProps) => {
    return (
        <div className="row">
            <div className="col-12">
                <HighchartsReact highcharts={Highcharts} options={options()} />
            </div>
        </div>
    );

    function options(): Highcharts.Options {
        return {
            chart: {
                backgroundColor: "transparent",
                type: "line",
                style: {
                    fontFamily: "inherit",
                },
            },

            title: {
                text: props.title,
            },

            xAxis: {
                tickWidth: 0,
                type: props.xAxis.type,
                labels: {
                    style: {
                        color: "var(--cta1)",
                    },
                    formatter: function () {
                        const date = new Date(this.value);
                        const month = JsonDateParser.getMonthNameMapping((date.getMonth() + 1).toString(), true);
                        const year = JsonDateParser.getFormatDate(JsonDateParser.toJsonDateNoOffset(date), "yy");

                        const formatDate = month + "'" + year;
                        return formatDate;
                    },
                },
            },

            yAxis: {
                title: null,
                labels: {
                    style: {
                        color: "var(--cta1)",
                    },
                    formatter: function () {
                        let ret = undefined,
                            numericSymbols = ["k", "M", "B", "T", "P", "E"],
                            i = numericSymbols.length;
                        if (this.value >= 1000) {
                            while (i-- && ret === undefined) {
                                const multi = Math.pow(1000, i + 1);
                                if (this.value >= multi && numericSymbols[i] !== null) {
                                    ret = this.value / multi + numericSymbols[i];
                                }
                            }
                        }
                        return ret !== undefined ? ret : this.value;
                    },
                },
            },

            legend: {
                enabled: false,
            },

            plotOptions: {
                series: {
                    label: {
                        connectorAllowed: false,
                    },
                    color: "var(--active)",
                    pointStart: 2010,
                },
            },

            series: props.series.map((series) => {
                return {
                    type: "line",
                    name: series.name,
                    data: series.data.map((datum) => {
                        return {
                            x: datum.xValue,
                            y: datum.yValue,
                        };
                    }),
                };
            }),

            responsive: {
                rules: [
                    {
                        condition: {
                            maxWidth: 500,
                        },
                    },
                ],
            },

            credits: {
                enabled: false,
            },

            tooltip: {
                useHTML: true,
                formatter: function () {
                    return props.tooltipFormatter(this);
                },
            },
        };
    }

    // function resolveXLabel(axisObject: Highcharts.AxisLabelsFormatterContextObject): string {
    //   switch (props.xAxis.type) {
    //     case "datetime":
    //       const date = new Date(axisObject.value);
    //       return DateHelper.getDateStringAsddmmmyyyy(date, true);
    //     default: axisObject.value.toString();
    //   }
    // }
};

export default LineChart;
